import React from "react";
import { useSelector } from "react-redux";
import MainLoader from '../../icons/MainLoader/MainLoader';
import { AppState } from '../../store'
import useTextContents from '../../hooks/useTextContents'

import "./WaitingScreen.scss";

const WaitingScreen = () => {
  const textContent = useTextContents()
  const waitingText = useSelector((state: AppState) => state.applicationState.waitingScreenText)

  const currentWaitingText = waitingText ? waitingText : textContent('loaders.default')

  return <MainLoader headingText={currentWaitingText} />
}


export default WaitingScreen;